module.exports = __webpack_public_path__ + "static/img/arooma.d983476e.png";